import { Component, OnInit } from '@angular/core';
import { CostRejectionTemplateService } from '../../services/cost-rejection-template.service';
import { FormControl, FormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';
import { ConfirmationService, SelectItem } from 'primeng';
import { IOptions } from 'minimatch';
import { CommsTemplateService } from '../../services';

@Component({
  selector: 'cost-rejection-reasons',
  templateUrl: './cost-rejection-reasons.component.html',
  styleUrls: ['./cost-rejection-reasons.component.scss'],
})
export class CostRejectionReasonsComponent implements OnInit {
  isLoaded = false;
  additionalCostResponses: {}[] = [];
  responseSelected = null;
  editForm: FormGroup;
  showEditForm: boolean;
  editMode: boolean;
  private preEditForm: any;
  showHelp = false;
  wrapperOptions: SelectItem[];

  constructor(
    private costRejectionService: CostRejectionTemplateService,
    private confirmationService: ConfirmationService,
    private commsTemplateService: CommsTemplateService,
  ) {}

  ngOnInit() {
    this.initForm();
    this.loadReasons();
    this.loadWrappers();
  }

  initForm() {
    this.editForm = new FormGroup({
      id: new FormControl(),
      headline: new FormControl(),
      templateWrapperId: new FormControl(),
      recipientAddressTemplate: new FormControl(),
      subjectTemplate: new FormControl(),
      bodyTemplate: new FormControl(),

      senderAddressTemplate: new FormControl(),
      senderNameTemplate: new FormControl(),

      replyToAddressTemplate: new FormControl(),
      replyToNameTemplate: new FormControl(),
    });
  }

  loadReasons() {
    this.isLoaded = false;

    this.costRejectionService.search().then((x) => {
      this.additionalCostResponses = x;
      this.showEditForm = false;
      this.isLoaded = true;
    });
  }

  loadWrappers() {
    this.commsTemplateService.fetchTemplateWrappers().then((x) => {
      this.wrapperOptions = x.map((item) => {
        return { label: item.templateName, value: item.id };
      });

      this.wrapperOptions.unshift({ label: 'No Wrapper', value: null });
    });
  }

  createResponse() {
    this.showEditForm = true;
    this.editMode = false;
    this.editForm.reset();
  }

  deleteResponse() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this item?',
      header: 'Confirmation',
      icon: 'pi pi-question',
      accept: () => {
        this.deleteConfirmed();
      },
    });
  }

  deleteConfirmed() {
    this.costRejectionService.delete(this.responseSelected.id).then((x) => {
      this.loadReasons();
    });
  }

  editResponse(item) {
    this.showEditForm = true;
    this.responseSelected = item;
    this.editMode = true;
    this.editForm.patchValue(item);
    this.preEditForm = Object.assign(this.editForm.value);
  }

  saveResponse() {
    if (this.responseSelected) {
      const patch = compare(this.preEditForm, this.editForm.value);

      console.log('PATCH ', patch);

      this.costRejectionService.patch(this.responseSelected.id, patch).then((x) => {
        this.loadReasons();
      });
    } else {
      this.costRejectionService.create(this.editForm.value).then((x) => {
        this.loadReasons();
      });
    }
  }
}
